// extracted by mini-css-extract-plugin
export default {"tableTitleCell":"EmployeeInformation_tableTitleCell__F2pSd","shynar":"EmployeeInformation_shynar__bwhwW"};